import React, { useEffect, useState } from 'react';
import { MultiSelect } from 'primereact/multiselect';
import { useDispatch, useSelector } from 'react-redux';
import { selectRegions, selectAccessToken } from '../../store/selectors';
import { getRegions } from '../../store/actions';

interface IRegionDropdownProperties {
  selectedValue: string[];
  onChange: (event: { value: string[] }) => void;
  allowedCodes?: string[];
}

const RegionDropdown: React.FC<IRegionDropdownProperties> = ({ selectedValue, onChange, allowedCodes }) => {
  const dispatch = useDispatch();
  const regions = useSelector(selectRegions);
  const accessToken = useSelector(selectAccessToken);
  const [options, setOptions] = useState<{ label: string; value: string }[]>([]);

  useEffect(() => {
    if (regions.length === 0 && accessToken) {
      dispatch(getRegions());
    }
  }, [dispatch, accessToken]);

  useEffect(() => {
    if (regions.length > 0) {
      const filteredRegions =
        allowedCodes === undefined ? regions : regions.filter((region) => allowedCodes.includes(region.code));
      const sortedOptions = filteredRegions
        .map((region) => ({
          label: `${region.code} - ${region.name}`,
          value: region.code,
        }))
        .sort((a, b) => a.label.localeCompare(b.label));
      setOptions(sortedOptions);
    }
  }, [regions, allowedCodes]);

  return (
    <MultiSelect
      id="regionDropdown"
      value={selectedValue}
      options={options}
      onChange={onChange}
      placeholder="Select Regions"
      display="chip"
      filter
    />
  );
};

export default RegionDropdown;
